const paths = {
    home: "/",
    dashboard: "/dashboard",
    login: "/login",
    logout: "/logout",
    register: "/register",
    userProfile: "/profile",
    statistics: "/statistics",
    finances: "/finances",
    invitationList: "/invitations",
    calendar: "/calendar",
    passwordReset: "/password-reset-confirm/:uid/:token",
    editProfile: "/edit-profile",
    changePassword: "/change-password",
    clients: "/clients",
    client: (clientId = ":clientId") => `/client/${clientId}`,
    createClient: "/create-client",
    editClient: (clientId = ":clientId") => `/client/${clientId}/edit`,
    projectList: "/project",
    createProject: "/project/create",
    project: (projectId = ":projectId") => `/project/${projectId}`,
    editProject: (projectId = ":projectId") => `/project/${projectId}/edit`,
    createTask: (projectId = ":projectId") => `/project/${projectId}/task/create`,
    taskDetails: (projectId = ":projectId", taskId = ":taskId") => `/project/${projectId}/task/${taskId}`,
    editTask: (projectId = ":projectId", taskId = ":taskId") => `/project/${projectId}/task/${taskId}/edit`,
    createSubtask: (projectId = ":projectId", taskId = ":taskId") => `/project/${projectId}/task/${taskId}/subtasks/create`,
    friends: "/friends",
    friendDetails: (friendId = ":friendId") => `/friend/${friendId}`,
};

export default paths;
